<template>
  <router-view />
</template>

<script>
export default {
  mounted () {
    console.log('Merchant View');
  },
}
</script>

<style scoped>

</style>
